module.exports = __webpack_public_path__ + "img/cloud-snow.db470b64.svg";